import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { Cookies } from 'react-cookie'
import { Dispatch, Store } from 'redux'
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import { persistStore } from 'redux-persist'

import { getUserInitialState } from '@/store/user/initialState'

import { ActionTypes } from './actions'
import reducer, { RootState } from './reducers'

let store: AppStore

export const makeStore = (cookies?: string) => {
  const preloadedState = {
    user: getUserInitialState(cookies),
  }
  store = configureStore({
    devTools: process.env.NODE_ENV !== 'production',
    middleware: getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
    preloadedState,
    reducer,
  })
  const persistor = persistStore(store)
  return { persistor, store }
}

export type AppStore = Store<RootState, ActionTypes> & {
  dispatch: Dispatch
}

export { store }
